import { setToken } from 'lib/common'
import { globalConst as native, mutationNames } from 'lib/const'
import { isEmptyObject, margeMutations } from 'lib/utils'
import { applyClientMiddleware } from 'src/main'
import api from 'api/api'
import PackageFile from 'lib/packageFile'
import { createModule } from 'plugins/vuex-request/VuexModule'

const state = {
  deviceList: []
}

const getters = {}
const actions = {
  [native.delDevice] ({state}, refs) {
    return applyClientMiddleware(api.delDevice, refs)
  },
  [native.doBindDevice] ({state}, refs) {
    return applyClientMiddleware(api.doBindDevice, refs)
  },
  [native.loadDeviceList] ({state}, refs) {
    return applyClientMiddleware(api.loadDeviceList, refs)
  },
  [native.updateDevice] ({state}, refs) {
    return applyClientMiddleware(api.updateDevice, refs)
  },
  [native.changeDevice] ({state}, refs) {
    return applyClientMiddleware(api.changeDevice, refs)
  },
}
let mutations = {
  setDeviceList (state, devList) {
    state.deviceList = devList
  },
  [mutationNames.loadDeviceList_success] (state, {refs, data}) {
    state.deviceList = data
  },
  setDeviceName (state, {index, deviceName}) {
    state.deviceList[index].name = deviceName
  }
}
mutations = Object.assign(margeMutations(actions), mutations)
export default createModule(state, getters, actions, mutations, false)
